import bathroom from "./bathroom.glb";
import bedroom from "./bedroom.glb";

export const models = { bathroom, bedroom };

export const modelSettings = {
    bathroom: {
        cameraPos: [0, 2, -3],
        cameraBox: [1.4, -1.4, 1, -1.2, 2, -1],
        envPos: [0, -13, -8],
        mirrorType: "plane",
        availableMeshes: [
            "Floor_Grout",
            "polySurface25_4_4",
            "polySurface25_4_3",
            "polySurface25_4_2",
            "Shower_Grout_Wall_1",
            "Shower_Grout_Wall_1_2",
            "Wall_1_1",
            "Wall_1_2",
            "Wall_1_3",
            "polySurface25_4_1",
            "Drain",
        ],
        group1: [
            "polySurface25_4_4",
            "polySurface25_4_3",
            "polySurface25_4_2",
            "Shower_Grout_Wall_1",
            "Shower_Grout_Wall_1_2",
        ],
        group2: ["Wall_1_1", "Wall_1_2", "Wall_1_3", "polySurface25_4_1"],
        group3: ["Drain"],
        lights: {
            directionalLights: [
                { pos: [0, 5.5, 0], power: 0.5, shadow: true },
                { pos: [3, -1.5, 0], power: 0.3 },
                { pos: [-4, -1.5, 0], power: 0.3 },
                { pos: [-1.7, 3.5, -5], power: 0.5 },
            ],
            shadowLights: [{ pos: [0, 2.7, -2.315], power: 0.25, dist: 5, decay: 0.2 }],
            mainLights: [
                { pos: [-0.915, 2.7, -0.7], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [-0.915, 2.7, -1.89], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [-0.915, 2.7, -3.08], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [-0.915, 2.7, -4.27], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [0.92, 2.7, -3.08], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [0.92, 2.7, -1.89], power: 0.25, dist: 5, decay: 0.2 },
                { pos: [0.92, 2.7, -0.7], power: 0.25, dist: 5, decay: 0.2 },
            ],
            wallLights: [
                { pos: [-1.55, 1.587, -0.485], power: 0.5 },
                { pos: [-1.55, 1.587, -1.56], power: 0.5 },
                { pos: [-1.55, 1.587, -2.635], power: 0.5 },
            ],
        },
        typeMeshes: {
            metal: [
                "Mesh011",
                "Mesh013",
                "Mesh022",
                "Mesh023",
                "Mesh025_1",
                "Mesh028_1",
                "Mesh034_1",
                "SinkFaucet",
                "Towe_lRack",
                "DoorHandle",
                "VanityHandles",
                "Shower_Floor",
            ],
            wall: [
                "Floor_Grout",
                "polySurface25_4_4",
                "polySurface25_4_3",
                "polySurface25_4_2",
                "Shower_Grout_Wall_1",
                "Shower_Grout_Wall_1_2",
                "Wall_1_1",
                "Wall_1_2",
                "Wall_1_3",
                "Wall_2",
                "polySurface25_4_1",
            ],
            wood: ["Trimming", "Mesh014", "Mesh014_1", "Mesh036", "Mesh036_1", "Mesh036_2"],
            wood2: ["Door_Panel", "VanityCabinet"],
            glass: ["Mesh025"],
            window: ["Mesh037", "Mesh038"],
            mirror: ["Mirror_Glass", "Mirror_Glass_1"],
            plastic: [
                "Mesh037_1",
                "Mesh038_1",
                "Mesh039",
                "Mesh039_2",
                "Mesh040",
                "Mesh040_1",
                "Mesh040_2",
            ],
            stone: ["VanityCounter"],
            ceramic: ["Sink"],
            notReceiveShadow: ["Mesh028", "Mesh011_2", "Mesh011_3"],
        },
    },

    bedroom: {
        cameraPos: [0, 2, 0],
        cameraBox: [2.4, -2.3, 1.2, -1.3, 4.3, 0.9],
        envPos: [0, -13, -5],
        mirrorType: "circle",
        availableMeshes: ["Wall_1", "Wall_2", "Wall_3", "Wall_4", "Floor_1"],
        group1: ["Wall_1", "Wall_2", "Wall_3", "Wall_4"],
        group2: [],
        group3: [],
        lights: {
            shadowLights: [
                // { pos: [0.1, 2.6, 0.3], power: 0.4, dist: 7, decay: 0.2 },
                { pos: [0.4, 2.6, 0.15], power: 0.4, dist: 7, decay: 0.2 },
            ],
            mainLights: [
                { pos: [-1.97, 2.85, 1.26], power: 0.4, dist: 7, decay: 0.2 },
                { pos: [-1.97, 2.85, -1.19], power: 0.4, dist: 7, decay: 0.2 },
                { pos: [2, 2.85, 1.26], power: 0.4, dist: 7, decay: 0.2 },
                { pos: [2, 2.85, -1.19], power: 0.4, dist: 7, decay: 0.2 },
            ],
        },
        typeMeshes: {
            metal: [
                "Cabinet_DresserHandles_All",
                "DoorHandle_Mesh",

                "Closet_Handle",
                "Mirror_Frame",
                "Cabinet_DresserBase_01",
                "Cabinet_nightstand_Legs_01",
                "Cabinet_nightstand_Handle_02",
                "Cabinet_nightstand_Handle_08",
                "Cabinet_nightstand_Legs_02",
            ],
            wall: ["Wall_1", "Wall_2", "Wall_3", "Wall_4", "Floor_1"],
            wood: ["Skirting_Mesh_1", "Door_Frame"],
            wood2: [
                "Door_PanelMiddle",
                "Cabinet_Dresser_shelves",
                "Cabinet_nightstand_01",
                "Cabinet_nightstand_02",
                "Cabinet_Frame1",
                "Cabinet_DoorPanel_1",
            ],
            glass: ["Mesh025"],
            window: ["Window_glass2", "Window_glass1"],
            mirror: ["Mirror_Glass"],
            plastic: [],
            stone: ["VanityCounter"],
            ceramic: ["Sink"],
            notReceiveShadow: ["Mesh028", "Mesh011_2", "Mesh011_3"],
        },
    },
};
